import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@wds/modal';
import { Button } from '@wds/button';

const UninstallConfirmModal = ({ showModal, handleConfirm, handleCancel, loading }) => {
  return (
    <Modal data-testid="UninstallConfirmModal__Dialog" show={showModal} size="md" onClose={handleCancel}>
      <Modal.Header header="Remove App" />
      <Modal.Body>Would you like to uninstall this app?</Modal.Body>
      <Modal.Footer align="right">
        <Button color="warning" onClick={handleConfirm} disabled={loading}>
          Uninstall
        </Button>
        <Button onClick={handleCancel} color="alt">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

UninstallConfirmModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  handleConfirm: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

UninstallConfirmModal.defaultProps = {
  loading: false,
};

export default UninstallConfirmModal;
